export const version = '2.45.4';
//# sourceMappingURL=version.js.map